import {ToolbarList} from "../../../../../../constant/imageEditor.constant";
import {useImageEditorContext} from "../../../../../../../../../../../../context/ImageEditorProvider";
import './ImageEditorToolbar.scss';

const ImageEditorToolbar = () => {
  const {ActiveToolbarId, handleSelectToolbarId} = useImageEditorContext();

  return (
    <div className='image-editor-toolbar'>
      {ToolbarList.map(toolbar => {
        const IsActiveParent = toolbar.id === ActiveToolbarId.ParentId;
        return (
          <div key={toolbar.id} className='image-editor-toolbar__wrapper'>
            <div
              className={`image-editor-toolbar__item${IsActiveParent ? ' active' : ''}`}
              onClick={() => handleSelectToolbarId({ParentId: toolbar.id, ChildId: ''})}
            >
              <img src={toolbar.icon} alt="image-editor-toolbar__item--icon"/>
            </div>

            <div className={`image-editor-toolbar-children${IsActiveParent ? ' active' : ''}`}>
              {toolbar.children?.map((toolbarChild) => {
                const IsActiveChild = toolbarChild.id === ActiveToolbarId.ChildId;
                return (
                  <div
                    key={toolbarChild.id}
                    className={`image-editor-toolbar-children__item${IsActiveChild ? ' active' : ''}`}
                    onClick={() => handleSelectToolbarId({ParentId: toolbar.id, ChildId: toolbarChild.id})}
                  >
                    {
                      toolbarChild.icon &&
                      <img src={toolbarChild.icon} alt='icon' className='image-editor-toolbar-children__item--icon' />
                    }
                    <span>{toolbarChild.name}</span>
                  </div>
                )
              })}
            </div>
          </div>
        )
      })}
    </div>
  );
};

export default ImageEditorToolbar;
